import { Box, Divider, Grid, InputAdornment, TextField, Typography } from "@mui/material";
import CommonVariant from "./CommonVariant";
import CommonScope from "./CommonScope";

const AdditionDeduction = ({
    additions,
    setAdditions,
    deductions,
    setDeductions,
    projectData,
    budget,
}) => {
    return (
        <>
            <Divider />
            <Box mt={1} mb={1}>
                <Typography sx={{ fontWeight: 'bold' }}>Additions</Typography>
                <Grid container spacing={1} mt={3}>
                    <Grid item xs={12} sm={6} md={2} sx={{ textAlign: 'center' }}>
                        <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>Budget Calculation Type</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} sx={{ textAlign: 'center' }}>
                        <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>Approved Budget</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} sx={{ textAlign: 'center' }}>
                        <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>Actual Calculation Type</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} sx={{ textAlign: 'center' }}>
                        <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>Actual</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} display="flex" alignItems="center" justifyContent="center">
                        <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>Tax</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <CommonVariant
                            type={additions?.tax?.approved?.type}
                            projectData={projectData}
                            label="Approved Tax Budget"
                            onRadioChange={(e) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    tax: {
                                        ...prevData.tax,
                                        approved: {
                                            ...prevData.tax?.approved,
                                            type: e.target.value,
                                            value: e.target.value === 'rate'
                                                ? ((prevData.tax.approved?.value * 100) / projectData?.total_approved_budget)
                                                : ((prevData.tax.approved?.value * projectData?.total_approved_budget) / 100)
                                        }
                                    }
                                }))
                            }}
                            onInputChange={(e) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    tax: {
                                        ...prevData.tax,
                                        approved: {
                                            ...prevData.tax?.approved,
                                            value: Number(e.target.value)
                                        }
                                    }
                                }))
                            }}
                            helperText={additions?.tax?.approved?.type === 'rate' ? "Percentage of Total Approved Budget" : "Amount Of Total Approved Budget"}
                            val={additions?.tax?.approved?.value}
                        />
                    </Grid>
                    <Grid item md={3} />
                    <Grid item xs={12} sm={6} md={3}>
                        <Box display="flex" gap={1} justifyContent="center">
                            <Box />
                            <Box>
                                <TextField
                                    id="standard-basic"
                                    label="Actual Tax"
                                    variant="standard"
                                    type="number"
                                    fullWidth
                                    disabled
                                    value={projectData.tax_rate || ''}
                                    slotProps={{
                                        input: {
                                            endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                        },
                                    }}
                                    sx={{
                                        '& .MuiInputBase-root': { fontSize: '0.85rem' },
                                        '& .MuiInputLabel-root': { fontSize: '0.8rem' },
                                        '& .MuiFormHelperText-root': { fontSize: '0.55rem' },
                                    }}
                                    helperText="The tax is coming from the Project"
                                />
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} display="flex" alignItems="center" justifyContent="center">
                        <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>Installation</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <CommonVariant
                            type={additions?.installation?.approved?.type}
                            projectData={projectData}
                            label="Approved Installation Budget"
                            onRadioChange={(e) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    installation: {
                                        ...prevData.installation,
                                        approved: {
                                            ...prevData.installation?.approved,
                                            type: e.target.value,
                                            value: e.target.value === 'rate'
                                                ? ((prevData.installation.approved?.value * 100) / projectData?.total_approved_budget)
                                                : ((prevData.installation.approved?.value * projectData?.total_approved_budget) / 100)
                                        }
                                    }
                                }))
                            }}
                            onInputChange={(e) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    installation: {
                                        ...prevData.installation,
                                        approved: {
                                            ...prevData.installation?.approved,
                                            value:  Number(e.target.value)
                                        }
                                    }
                                }))
                            }}
                            helperText={additions?.installation?.approved?.type === 'rate' ? "Percentage of Total Approved Budget" : "Amount Of Total Approved Budget"}
                            val={additions?.installation?.approved?.value}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <CommonScope
                            val={additions?.installation?.actual?.scope}
                            onSelectChange={(event, newValue) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    installation: {
                                        ...prevData.installation,
                                        actual: {
                                            ...prevData.installation?.actual,
                                            scope: newValue?.value,
                                            itemValue: prevData?.installation?.actual?.type === 'rate'
                                                ? parseFloat(((budget?.total_installation * 100) / budget?.total_cost)).toFixed(2)
                                                : budget?.total_installation
                                        }
                                    }
                                }));
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <CommonVariant
                            type={additions?.installation?.actual?.type}
                            projectData={projectData}
                            label="Actual Installation"
                            onRadioChange={(e) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    installation: {
                                        ...prevData.installation,
                                        actual: {
                                            ...prevData.installation?.actual,
                                            type: e.target.value,
                                            value: e.target.value === 'rate'
                                                ? ((prevData.installation.actual?.value * 100) / budget?.total_cost)
                                                : ((prevData.installation.actual?.value * budget?.total_cost) / 100),
                                            itemValue: e.target.value === 'rate'
                                                ? parseFloat(((budget?.total_installation * 100) / budget?.total_cost)).toFixed(2)
                                                : budget?.total_installation
                                        }
                                    }
                                }));
                            }}
                            onInputChange={(e) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    installation: {
                                        ...prevData.installation,
                                        actual: {
                                            ...prevData.installation?.actual,
                                            value:  Number(e.target.value)
                                        }
                                    }
                                }))
                            }}
                            helperText={additions?.installation?.actual?.scope === 'project' ? "The Installation value is coming from the Project" : "The Installation value is coming from the Items"}
                            val={additions?.installation?.actual?.scope === 'project' ? additions?.installation?.actual?.value : additions?.installation?.actual?.itemValue}
                            disabled={additions?.installation?.actual?.scope === 'item'}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} display="flex" alignItems="center" justifyContent="center">
                        <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>Storage</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <CommonVariant
                            type={additions?.storage?.approved?.type}
                            projectData={projectData}
                            label="Approved Storage Budget"
                            onRadioChange={(e) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    storage: {
                                        ...prevData.storage,
                                        approved: {
                                            ...prevData.storage?.approved,
                                            type: e.target.value,
                                            value: e.target.value === 'rate'
                                                ? ((prevData.storage.approved?.value * 100) / projectData?.total_approved_budget)
                                                : ((prevData.storage.approved?.value * projectData?.total_approved_budget) / 100)
                                        }
                                    }
                                }))
                            }}
                            onInputChange={(e) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    storage: {
                                        ...prevData.storage,
                                        approved: {
                                            ...prevData.storage?.approved,
                                            value:  Number(e.target.value)
                                        }
                                    }
                                }))
                            }}
                            helperText={additions?.storage?.approved?.type === 'rate' ? "Percentage of Total Approved Budget" : "Amount Of Total Approved Budget"}
                            val={additions?.storage?.approved?.value}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <CommonScope
                            val={additions?.storage?.actual?.scope}
                            onSelectChange={(event, newValue) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    storage: {
                                        ...prevData.storage,
                                        actual: {
                                            ...prevData.storage?.actual,
                                            scope: newValue?.value,
                                            itemValue: prevData?.storage?.actual?.type === 'rate'
                                                ? parseFloat(((budget?.total_storage * 100) / budget?.total_cost)).toFixed(2)
                                                : budget?.total_storage
                                        }
                                    }
                                }));
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <CommonVariant
                            type={additions?.storage?.actual?.type}
                            projectData={projectData}
                            label="Actual Storage"
                            onRadioChange={(e) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    storage: {
                                        ...prevData.storage,
                                        actual: {
                                            ...prevData.storage?.actual,
                                            type: e.target.value,
                                            value: e.target.value === 'rate'
                                                ? ((prevData.storage.actual?.value * 100) / budget?.total_cost)
                                                : ((prevData.storage.actual?.value * budget?.total_cost) / 100),
                                            itemValue: e.target.value === 'rate'
                                                ? parseFloat(((budget?.total_storage * 100) / budget?.total_cost)).toFixed(2)
                                                : budget?.total_storage
                                        }
                                    }
                                }));
                            }}
                            onInputChange={(e) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    storage: {
                                        ...prevData.storage,
                                        actual: {
                                            ...prevData.storage?.actual,
                                            value:  Number(e.target.value)
                                        }
                                    }
                                }))
                            }}
                            helperText={additions?.storage?.actual?.scope === 'project' ? "The Storage value is coming from the Project" : "The Storage value is coming from the Items"}
                            val={additions?.storage?.actual?.scope === 'project' ? additions?.storage?.actual?.value : additions?.storage?.actual?.itemValue}
                            disabled={additions?.storage?.actual?.scope === 'item'}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} display="flex" alignItems="center" justifyContent="center">
                        <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>Freight</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <CommonVariant
                            type={additions?.freight?.approved?.type}
                            projectData={projectData}
                            label="Approved Freight Budget"
                            onRadioChange={(e) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    freight: {
                                        ...prevData.freight,
                                        approved: {
                                            ...prevData.freight?.approved,
                                            type: e.target.value,
                                            value: e.target.value === 'rate'
                                                ? ((prevData.freight.approved?.value * 100) / projectData?.total_approved_budget)
                                                : ((prevData.freight.approved?.value * projectData?.total_approved_budget) / 100)
                                        }
                                    }
                                }))
                            }}
                            onInputChange={(e) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    freight: {
                                        ...prevData.freight,
                                        approved: {
                                            ...prevData.freight?.approved,
                                            value:  Number(e.target.value)
                                        }
                                    }
                                }))
                            }}
                            helperText={additions?.freight?.approved?.type === 'rate' ? "Percentage of Total Approved Budget" : "Amount Of Total Approved Budget"}
                            val={additions?.freight?.approved?.value}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <CommonScope
                            val={additions?.freight?.actual?.scope}
                            onSelectChange={(event, newValue) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    freight: {
                                        ...prevData.freight,
                                        actual: {
                                            ...prevData.freight?.actual,
                                            scope: newValue?.value,
                                            itemValue: prevData?.freight?.actual?.type === 'rate'
                                                ? parseFloat(((budget?.total_freight * 100) / budget?.total_cost)).toFixed(2)
                                                : budget?.total_freight
                                        }
                                    }
                                }));
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <CommonVariant
                            type={additions?.freight?.actual?.type}
                            projectData={projectData}
                            label="Actual Freight"
                            onRadioChange={(e) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    freight: {
                                        ...prevData.freight,
                                        actual: {
                                            ...prevData.freight?.actual,
                                            type: e.target.value,
                                            value: e.target.value === 'rate'
                                                ? ((prevData.freight.actual?.value * 100) / budget?.total_cost)
                                                : ((prevData.freight.actual?.value * budget?.total_cost) / 100),
                                            itemValue: e.target.value === 'rate'
                                                ? parseFloat(((budget?.total_freight * 100) / budget?.total_cost)).toFixed(2)
                                                : budget?.total_freight
                                        }
                                    }
                                }));
                            }}
                            onInputChange={(e) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    freight: {
                                        ...prevData.freight,
                                        actual: {
                                            ...prevData.freight?.actual,
                                            value:  Number(e.target.value)
                                        }
                                    }
                                }))
                            }}
                            helperText={additions?.freight?.actual?.scope === 'project' ? "The Freight value is coming from the Project" : "The Freight value is coming from the Items"}
                            val={additions?.freight?.actual?.scope === 'project' ? additions?.freight?.actual?.value : additions?.freight?.actual?.itemValue}
                            disabled={additions?.freight?.actual?.scope === 'item'}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} display="flex" alignItems="center" justifyContent="center">
                        <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>Fees</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <CommonVariant
                            type={additions?.fees?.approved?.type}
                            projectData={projectData}
                            label="Approved Fees Budget"
                            onRadioChange={(e) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    fees: {
                                        ...prevData.fees,
                                        approved: {
                                            ...prevData.fees?.approved,
                                            type: e.target.value,
                                            value: e.target.value === 'rate'
                                                ? ((prevData.fees.approved?.value * 100) / projectData?.total_approved_budget)
                                                : ((prevData.fees.approved?.value * projectData?.total_approved_budget) / 100)
                                        }
                                    }
                                }))
                            }}
                            onInputChange={(e) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    fees: {
                                        ...prevData.fees,
                                        approved: {
                                            ...prevData.fees?.approved,
                                            value:  Number(e.target.value)
                                        }
                                    }
                                }))
                            }}
                            helperText={additions?.fees?.approved?.type === 'rate' ? "Percentage of Total Approved Budget" : "Amount Of Total Approved Budget"}
                            val={additions?.fees?.approved?.value}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <CommonScope
                            val={additions?.fees?.actual?.scope}
                            onSelectChange={(event, newValue) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    fees: {
                                        ...prevData.fees,
                                        actual: {
                                            ...prevData.fees?.actual,
                                            scope: newValue?.value,
                                            itemValue: prevData?.fees?.actual?.type === 'rate'
                                                ? parseFloat(((budget?.total_fees * 100) / budget?.total_cost)).toFixed(2)
                                                : budget?.total_fees
                                        }
                                    }
                                }));
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <CommonVariant
                            type={additions?.fees?.actual?.type}
                            projectData={projectData}
                            label="Actual Fees"
                            onRadioChange={(e) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    fees: {
                                        ...prevData.fees,
                                        actual: {
                                            ...prevData.fees?.actual,
                                            type: e.target.value,
                                            value: e.target.value === 'rate'
                                                ? ((prevData.fees.actual?.value * 100) / budget?.total_cost)
                                                : ((prevData.fees.actual?.value * budget?.total_cost) / 100),
                                            itemValue: e.target.value === 'rate'
                                                ? parseFloat(((budget?.total_fees * 100) / budget?.total_cost)).toFixed(2)
                                                : budget?.total_fees
                                        }
                                    }
                                }));
                            }}
                            onInputChange={(e) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    fees: {
                                        ...prevData.fees,
                                        actual: {
                                            ...prevData.fees?.actual,
                                            value:  Number(e.target.value)
                                        }
                                    }
                                }))
                            }}
                            helperText={additions?.fees?.actual?.scope === 'project' ? "The Fees value is coming from the Project" : "The Fees value is coming from the Items"}
                            val={additions?.fees?.actual?.scope === 'project' ? additions?.fees?.actual?.value : additions?.fees?.actual?.itemValue}
                            disabled={additions?.fees?.actual?.scope === 'item'}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} display="flex" alignItems="center" justifyContent="center">
                        <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>Contingency</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <CommonVariant
                            type={additions?.contingency?.approved?.type}
                            projectData={projectData}
                            label="Approved Contingency Budget"
                            onRadioChange={(e) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    contingency: {
                                        ...prevData.contingency,
                                        approved: {
                                            ...prevData.contingency?.approved,
                                            type: e.target.value,
                                            value: e.target.value === 'rate'
                                                ? ((prevData.contingency.approved?.value * 100) / projectData?.total_approved_budget)
                                                : ((prevData.contingency.approved?.value * projectData?.total_approved_budget) / 100)
                                        }
                                    }
                                }))
                            }}
                            onInputChange={(e) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    contingency: {
                                        ...prevData.contingency,
                                        approved: {
                                            ...prevData.contingency?.approved,
                                            value:  Number(e.target.value)
                                        }
                                    }
                                }))
                            }}
                            helperText={additions?.contingency?.approved?.type === 'rate' ? "Percentage of Total Approved Budget" : "Amount Of Total Approved Budget"}
                            val={additions?.contingency?.approved?.value}
                        />
                    </Grid>
                    <Grid item md={3} />
                    <Grid item xs={12} sm={6} md={3}>
                        <CommonVariant
                            type={additions?.contingency?.actual?.type}
                            projectData={projectData}
                            label="Actual Contingency"
                            onRadioChange={(e) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    contingency: {
                                        ...prevData.contingency,
                                        actual: {
                                            ...prevData.contingency?.actual,
                                            type: e.target.value,
                                            value: e.target.value === 'rate'
                                                ? ((prevData.contingency?.actual?.value * 100) / budget?.total_cost)
                                                : ((prevData.contingency?.actual?.value * budget?.total_cost) / 100)
                                        }
                                    }
                                }));
                            }}
                            onInputChange={(e) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    contingency: {
                                        ...prevData.contingency,
                                        actual: {
                                            ...prevData.contingency?.actual,
                                            value:  Number(e.target.value)
                                        }
                                    }
                                }))
                            }}
                            helperText="The Contingency value is coming from the Project"
                            val={additions?.contingency?.actual?.value}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} display="flex" alignItems="center" justifyContent="center">
                        <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>Inflation</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <CommonVariant
                            type={additions?.inflation?.approved?.type}
                            projectData={projectData}
                            label="Approved Inflation Budget"
                            onRadioChange={(e) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    inflation: {
                                        ...prevData.inflation,
                                        approved: {
                                            ...prevData.inflation?.approved,
                                            type: e.target.value,
                                            value: e.target.value === 'rate'
                                                ? ((prevData.inflation.approved?.value * 100) / projectData?.total_approved_budget)
                                                : ((prevData.inflation.approved?.value * projectData?.total_approved_budget) / 100)
                                        }
                                    }
                                }))
                            }}
                            onInputChange={(e) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    inflation: {
                                        ...prevData.inflation,
                                        approved: {
                                            ...prevData.inflation?.approved,
                                            value:  Number(e.target.value)
                                        }
                                    }
                                }))
                            }}
                            helperText={additions?.inflation?.approved?.type === 'rate' ? "Percentage of Total Approved Budget" : "Amount Of Total Approved Budget"}
                            val={additions?.inflation?.approved?.value}
                        />
                    </Grid>
                    <Grid item md={3} />
                    <Grid item xs={12} sm={6} md={3}>
                        <CommonVariant
                            type={additions?.inflation?.actual?.type}
                            projectData={projectData}
                            label="Actual Inflation"
                            onRadioChange={(e) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    inflation: {
                                        ...prevData.inflation,
                                        actual: {
                                            ...prevData.inflation?.actual,
                                            type: e.target.value,
                                            value: e.target.value === 'rate'
                                                ? ((prevData.inflation.actual?.value * 100) / budget?.total_cost)
                                                : ((prevData.inflation.actual?.value * budget?.total_cost) / 100)
                                        }
                                    }
                                }));
                            }}
                            onInputChange={(e) => {
                                setAdditions((prevData) => ({
                                    ...prevData,
                                    inflation: {
                                        ...prevData.inflation,
                                        actual: {
                                            ...prevData.inflation?.actual,
                                            value:  Number(e.target.value)
                                        }
                                    }
                                }))
                            }}
                            helperText="The Inflation value is coming from the Project"
                            val={additions?.inflation?.actual?.value}
                        />
                    </Grid>
                </Grid>
            </Box>
            <Divider />
            <Box mt={1} mb={1}>
                <Typography sx={{ fontWeight: 'bold' }}>Deductions</Typography>
                <Grid container spacing={1} mt={3}>
                    <Grid item xs={12} sm={6} md={2} sx={{ textAlign: 'center' }}>
                        <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>Budget Calculation Type</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} sx={{ textAlign: 'center' }}>
                        <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>Approved Budget</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} sx={{ textAlign: 'center' }}>
                        <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>Actual Calculation Type</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} sx={{ textAlign: 'center' }}>
                        <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>Actual</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} display="flex" alignItems="center" justifyContent="center">
                        <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>Discounts</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <CommonVariant
                            type={deductions?.discount?.approved?.type}
                            projectData={projectData}
                            label="Approved Discount Budget"
                            onRadioChange={(e) => {
                                setDeductions((prevData) => ({
                                    ...prevData,
                                    discount: {
                                        ...prevData.discount,
                                        approved: {
                                            ...prevData.discount?.approved,
                                            type: e.target.value,
                                            value: e.target.value === 'rate'
                                                ? ((prevData.discount.approved?.value * 100) / projectData?.total_approved_budget)
                                                : ((prevData.discount.approved?.value * projectData?.total_approved_budget) / 100)
                                        }
                                    }
                                }))
                            }}
                            onInputChange={(e) => {
                                setDeductions((prevData) => ({
                                    ...prevData,
                                    discount: {
                                        ...prevData.discount,
                                        approved: {
                                            ...prevData.discount?.approved,
                                            value:  Number(e.target.value)
                                        }
                                    }
                                }))
                            }}
                            helperText={deductions?.discount?.approved?.type === 'rate' ? "Percentage of Total Approved Budget" : "Amount Of Total Approved Budget"}
                            val={deductions?.discount?.approved?.value}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <CommonScope
                            val={deductions?.discount?.actual?.scope}
                            onSelectChange={(event, newValue) => {
                                setDeductions((prevData) => ({
                                    ...prevData,
                                    discount: {
                                        ...prevData.discount,
                                        actual: {
                                            ...prevData.discount?.actual,
                                            scope: newValue?.value,
                                            itemValue: prevData?.discount?.actual?.type === 'rate'
                                                ? parseFloat(((budget?.total_discounts * 100) / budget?.total_cost)).toFixed(2)
                                                : budget?.total_discounts
                                        }
                                    }
                                }));
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <CommonVariant
                            type={deductions?.discount?.actual?.type}
                            projectData={projectData}
                            label="Actual Discount"
                            onRadioChange={(e) => {
                                setDeductions((prevData) => ({
                                    ...prevData,
                                    discount: {
                                        ...prevData.discount,
                                        actual: {
                                            ...prevData.discount?.actual,
                                            type: e.target.value,
                                            value: e.target.value === 'rate'
                                                ? ((prevData.discount.actual?.value * 100) / budget?.total_cost)
                                                : ((prevData.discount.actual?.value * budget?.total_cost) / 100),
                                            itemValue: e.target.value === 'rate'
                                                ? parseFloat(((budget?.total_discounts * 100) / budget?.total_cost)).toFixed(2)
                                                : budget?.total_discounts
                                        }
                                    }
                                }));
                            }}
                            onInputChange={(e) => {
                                setDeductions((prevData) => ({
                                    ...prevData,
                                    discount: {
                                        ...prevData.discount,
                                        actual: {
                                            ...prevData.discount?.actual,
                                            value:  Number(e.target.value)
                                        }
                                    }
                                }))
                            }}
                            helperText={deductions?.discount?.actual?.scope === 'project' ? "The Discounts value is coming from the Project" : "The Discounts value is coming from the Items"}
                            val={deductions?.discount?.actual?.scope === 'project' ? deductions?.discount?.actual?.value : deductions?.discount?.actual?.itemValue}
                            disabled={deductions?.discount?.actual?.scope === 'item'}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} display="flex" alignItems="center" justifyContent="center">
                        <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>Trade In</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} sx={{ textAlign: 'center' }}>
                        <CommonVariant
                            type={deductions?.reuse?.approved?.type}
                            projectData={projectData}
                            label="Approved Trade In Budget"
                            onRadioChange={(e) => {
                                setDeductions((prevData) => ({
                                    ...prevData,
                                    reuse: {
                                        ...prevData.reuse,
                                        approved: {
                                            ...prevData.reuse?.approved,
                                            type: e.target.value,
                                            value: e.target.value === 'rate'
                                                ? ((prevData.reuse.approved?.value * 100) / projectData?.total_approved_budget)
                                                : ((prevData.reuse.approved?.value * projectData?.total_approved_budget) / 100)
                                        }
                                    }
                                }))
                            }}
                            onInputChange={(e) => {
                                setDeductions((prevData) => ({
                                    ...prevData,
                                    reuse: {
                                        ...prevData.reuse,
                                        approved: {
                                            ...prevData.reuse?.approved,
                                            value:  Number(e.target.value)
                                        }
                                    }
                                }))
                            }}
                            helperText={deductions?.reuse?.approved?.type === 'rate' ? "Percentage of Total Approved Budget" : "Amount Of Total Approved Budget"}
                            val={deductions?.reuse?.approved?.value}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <CommonScope
                            val={deductions?.reuse?.actual?.scope}
                            onSelectChange={(event, newValue) => {
                                setDeductions((prevData) => ({
                                    ...prevData,
                                    reuse: {
                                        ...prevData.discount,
                                        actual: {
                                            ...prevData.reuse?.actual,
                                            scope: newValue?.value,
                                            itemValue: prevData?.reuse?.actual?.type === 'rate'
                                                ? parseFloat(((budget?.total_tradein * 100) / budget?.total_cost)).toFixed(2)
                                                : budget?.total_tradein
                                        }
                                    }
                                }));
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <CommonVariant
                            type={deductions?.reuse?.actual?.type}
                            projectData={projectData}
                            label="Actual Trade In"
                            onRadioChange={(e) => {
                                setDeductions((prevData) => ({
                                    ...prevData,
                                    reuse: {
                                        ...prevData.reuse,
                                        actual: {
                                            ...prevData.reuse?.actual,
                                            type: e.target.value,
                                            value: e.target.value === 'rate'
                                                ? ((prevData.reuse.actual?.value * 100) / budget?.total_cost)
                                                : ((prevData.reuse.actual?.value * budget?.total_cost) / 100),
                                            itemValue: e.target.value === 'rate'
                                                ? parseFloat(((budget?.total_tradein * 100) / budget?.total_cost)).toFixed(2)
                                                : budget?.total_tradein
                                        }
                                    }
                                }))
                            }}
                            onInputChange={(e) => {
                                setDeductions((prevData) => ({
                                    ...prevData,
                                    reuse: {
                                        ...prevData.reuse,
                                        actual: {
                                            ...prevData.reuse?.actual,
                                            value:  Number(e.target.value)
                                        }
                                    }
                                }))
                            }}
                            helperText={deductions?.reuse?.actual?.scope === 'project' ? "The Trade In value is coming from the Project" : "The Trade In value is coming from the Items"}
                            val={deductions?.reuse?.actual?.scope === 'project' ? deductions?.reuse?.actual?.value : deductions?.reuse?.actual?.itemValue}
                            disabled={deductions?.reuse?.actual?.scope === 'item'}
                        />
                    </Grid>
                </Grid>
            </Box>
            <Divider />
        </>
    )
}

export default AdditionDeduction;